module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABBUlEQVR42qXSv23CUBDH8e87x5iSERjBK1AmNMkECOUPcpkNyBCRJRTxsoGTAlFamYAVPAJljGW/NKGIFT+fxXUnnT466fczANu3/aKsvr+S5K5gwFibTZoqsqe6fBYA17j1KIjyNM2mQxBXjXLgNpQoFgCpzQxAi50Rh4nBLR9WNx8CsEyuCy3WRu6f5u8Acj7QYF3IH6gP8yEA5t/30/20CVwOcKrL2XjM0Yd0Qm3M4I4+xAsBbF53cRCaA0Dj3Mvjar7uuhVfOlch9nctxJiFL03RRKyphmgi1lRDtD3pw0Tbkz5MtEgfZgC2m91Bg/hKKwC143MI0v4slCjm0rE2mwD8AJsA4DYbnI0uAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/Booking/cross.png
// module id = 576
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22